module.exports = __webpack_public_path__ + "img/icon-schedule.b5404c80.svg";